import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/esnext.string.replace-all.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { Events } from '@phx-husky/auth-service';
import { Button as Button$1 } from '@phx-husky/button-auth';
import { triggerCustomEvent } from '@phx-husky/custom-event';
import { Field, FieldType, ConditionalWrapper } from '@phx-husky/field';
import { CloseIcon } from '@phx-husky/icons';
import { Loader } from '@phx-husky/loader';
import { Modal } from '@phx-husky/modal';
import { useConfig } from '@phx-husky/use-config';
import { useSignUp } from '@phx-husky/use-sign-up';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import { useState, useMemo, useEffect, useCallback } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Button } from '@design-system/button';
import { Typography } from '@design-system/typography';
import { useForm } from '@phx-husky/use-form';
import ConfirmCode from '@phx-husky/confirm-code';
import { InformationModal } from '@phx-husky/information-modal';
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z$1 = ".register-module_register__kr9Tm {\n  width: 100%;\n  font-family: var(--phx-fontFamily, Lato, sans-serif);\n  padding: var(--phx-registerModalPadding, var(--cds-space-6) var(--cds-space-3));\n  margin: 0 auto;\n}\n\n@media screen and (min-width: 576px) {\n  .register-module_register__kr9Tm {\n    width: var(--phx-registerModalWidth, 360px);\n  }\n}\n\n.register-module_container__9q8FH {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.register-module_form__Ry-gh {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.register-module_logo__9AxaU {\n  margin-bottom: var(--cds-space-3);\n}\n\n.register-module_switchModeWrapper__Sryle {\n  align-self: start;\n  margin-bottom: var(--cds-space-5);\n}\n\n.register-module_switchModeText__5HKN4 {\n  color: var(--phx-textColor, #101010);\n}\n\n.register-module_title__twS7F {\n  align-self: start;\n  color: var(--phx-textColor, #101010);\n}\n\n.register-module_description__mel4J {\n  margin: var(--cds-space-5) 0 var(--cds-space-6) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n\n.register-module_submit__EsdGi {\n  width: 100%;\n  margin-top: var(--cds-space-5);\n}\n\n.register-module_errorMessage__ds2nm {\n  margin: var(--cds-space-2) 0;\n}\n\n.register-module_errorMessage__ds2nm.cds-error-icon {\n  margin: 0px;\n  width: var(--cds-icon-size-xs);\n  height: var(--cds-icon-size-xs);\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$1 = {
  "register": "register-module_register__kr9Tm",
  "container": "register-module_container__9q8FH",
  "form": "register-module_form__Ry-gh",
  "logo": "register-module_logo__9AxaU",
  "switchModeWrapper": "register-module_switchModeWrapper__Sryle",
  "switchModeText": "register-module_switchModeText__5HKN4",
  "title": "register-module_title__twS7F",
  "description": "register-module_description__mel4J",
  "submit": "register-module_submit__EsdGi",
  "errorMessage": "register-module_errorMessage__ds2nm"
};
styleInject(css_248z$1);
var css_248z = ".confirmation-module_title__LSdzt {\n  color: var(--phx-textColor, #101010);\n}\n\n.confirmation-module_description__7oo9L {\n  margin: var(--cds-space-5) 0 var(--cds-space-6) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm1hdGlvbi5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLG9DQUFvQztBQUN0Qzs7QUFFQTtFQUNFLGlEQUFpRDtFQUNqRCw2Q0FBNkM7QUFDL0MiLCJmaWxlIjoiY29uZmlybWF0aW9uLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnRpdGxlIHtcbiAgY29sb3I6IHZhcigtLXBoeC10ZXh0Q29sb3IsICMxMDEwMTApO1xufVxuXG4uZGVzY3JpcHRpb24ge1xuICBtYXJnaW46IHZhcigtLWNkcy1zcGFjZS01KSAwIHZhcigtLWNkcy1zcGFjZS02KSAwO1xuICBjb2xvcjogdmFyKC0tcGh4LXNlY29uZGFyeVRleHRDb2xvciwgIzRhNGE0YSk7XG59Il19 */";
var styles = {
  "title": "confirmation-module_title__LSdzt",
  "description": "confirmation-module_description__7oo9L"
};
styleInject(css_248z);
var Confirmation = function Confirmation(_ref) {
  var attributeValue = _ref.attributeValue,
    email = _ref.email,
    codeDeliveryMedium = _ref.codeDeliveryMedium,
    confirmCallback = _ref.confirmCallback;
  var _useTranslations = useTranslations(),
    translate = _useTranslations.translate;
  var _useSignUp = useSignUp(),
    confirmSignUp = _useSignUp.confirmSignUp,
    resendSignUpCode = _useSignUp.resendSignUpCode;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    pending = _useState4[0],
    setPending = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    congratulationInfo = _useState6[0],
    setCongratulationInfo = _useState6[1];
  var payload = {
    prefix: 'confirmation',
    translationPrefix: 'register'
  };
  var congratulationCallback = function congratulationCallback() {
    triggerCustomEvent(Events.onSuccessActionConfirmation, {
      visible: false
    });
  };
  var submit = function submit(e, verificationCode) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var confirmation;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              if (verificationCode) {
                _context.next = 4;
                break;
              }
              setErrorMessage(translate('confirmationCodeRequiredErrorMessage'));
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return confirmSignUp({
                username: email,
                verificationCode: verificationCode
              });
            case 6:
              confirmation = _context.sent;
              if (confirmation === null || confirmation === void 0 ? void 0 : confirmation.success) {
                setCongratulationInfo(true);
                if (confirmCallback) {
                  confirmCallback({
                    confirmedEmail: email
                  });
                }
              } else {
                setErrorMessage((confirmation === null || confirmation === void 0 ? void 0 : confirmation.message) || '');
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
  var resendCode = function resendCode(e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              setPending(true);
              _context2.prev = 2;
              _context2.next = 5;
              return resendSignUpCode({
                username: email
              });
            case 5:
              setPending(false);
              _context2.next = 12;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              setPending(false);
              setErrorMessage(_context2.t0);
            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 8]]);
    }));
  };
  return jsx("div", Object.assign({
    className: classNames(styles.confirmation, 'register__confirmation')
  }, {
    children: !congratulationInfo ? jsxs(Fragment, {
      children: [jsx(Typography, {
        tag: "h2",
        variant: "headline",
        size: "m",
        weight: "bold",
        className: styles.title,
        "data-translate-key": "registerConfirmTitle",
        content: translate('registerConfirmTitle')
      }), jsx(Typography, {
        tag: "p",
        variant: "body",
        size: "m",
        className: styles.description,
        "data-translate-key": "registerConfirmationCheckInfo".concat(codeDeliveryMedium),
        content: "".concat(translate("registerConfirmationCheckInfo".concat(codeDeliveryMedium)), " <strong>").concat(attributeValue, "</strong>")
      }), jsx(ConfirmCode, {
        additionalData: payload,
        submit: submit,
        attributeValue: attributeValue,
        errorMessage: errorMessage,
        resendCode: resendCode,
        pending: pending
      })]
    }) : jsx(InformationModal, {
      message: translate('registerCongratulationText'),
      title: translate('registerCongratulationTitle'),
      callback: congratulationCallback,
      buttonTitle: translate('registerCongratulationButton')
    })
  }));
};
var RegisterForm = function RegisterForm(_ref2) {
  var onClickSignIn = _ref2.onClickSignIn,
    signUpFields = _ref2.signUpFields,
    submit = _ref2.submit,
    close = _ref2.close,
    codeDeliveryDetails = _ref2.codeDeliveryDetails,
    pending = _ref2.pending,
    confirmAccountWithEmail = _ref2.confirmAccountWithEmail,
    confirmCallback = _ref2.confirmCallback;
  var _useSignUp2 = useSignUp(),
    validate = _useSignUp2.validate;
  var _useTranslations2 = useTranslations(),
    translate = _useTranslations2.translate;
  var fieldStatesInit = useMemo(function () {
    return Object.keys(signUpFields).reduce(function (prev, curr) {
      return Object.assign(Object.assign({}, prev), _defineProperty({}, curr, ''));
    }, {});
  }, [signUpFields]);
  var _useForm = useForm({
      initialValues: fieldStatesInit,
      callback: submit,
      validate: validate,
      validateOnChange: true
    }),
    values = _useForm.values,
    errors = _useForm.errors,
    handleChange = _useForm.handleChange,
    handleSubmit = _useForm.handleSubmit;
  var openLoginModal = function openLoginModal() {
    triggerCustomEvent(Events.onSignInClick, {
      visible: true
    });
  };
  return !codeDeliveryDetails ? jsxs("form", Object.assign({
    className: classNames(styles$1.form, 'register__form'),
    onSubmit: handleSubmit,
    id: "register-form"
  }, {
    children: [jsx("div", Object.assign({
      className: styles$1.switchModeWrapper
    }, {
      children: jsx(Button, Object.assign({
        type: "button",
        variant: "subtle",
        className: styles$1.switchModeButton,
        id: "register-switch-mode-button",
        onClick: function onClick() {
          if (onClickSignIn) {
            onClickSignIn();
          } else {
            close();
            openLoginModal();
          }
        }
      }, {
        children: jsx(Typography, {
          tag: "span",
          variant: "body",
          size: "s",
          className: styles$1.switchModeText,
          "data-translate-key": "registerSignInInformationSubtitle",
          content: "".concat(translate('registerSignInInformationSubtitle'), " <strong>").concat(translate('registerSignInInformationButton'), "</strong>")
        })
      }))
    })), jsx(Typography, {
      tag: "h2",
      variant: "headline",
      size: "m",
      weight: "bold",
      className: styles$1.title,
      "data-translate-key": "registerTitle",
      content: translate('registerTitle')
    }), jsx(Typography, {
      tag: "p",
      variant: "body",
      size: "m",
      className: styles$1.description,
      "data-translate-key": "registerDescription",
      content: translate('registerDescription')
    }), Object.entries(signUpFields).map(function (_a) {
      var _b;
      var _a2 = _slicedToArray(_a, 2),
        name = _a2[0],
        _c = _a2[1],
        id = _c.id,
        label = _c.label,
        type = _c.type,
        rest = __rest(_c, ["id", "label", "type"]);
      return jsx(Field, Object.assign({
        id: id,
        name: name,
        type: FieldType[type],
        label: label,
        value: values[name],
        onChange: handleChange,
        errorMessage: (_b = errors === null || errors === void 0 ? void 0 : errors.validation) === null || _b === void 0 ? void 0 : _b[name].message
      }, rest), id);
    }), jsx(Button, Object.assign({
      type: "submit",
      variant: "primary",
      size: "large",
      className: classNames(styles$1.submit, 'register__submit'),
      id: "register-submit",
      "data-translate-key": "registerSubmitButton",
      isLoading: pending,
      disabled: pending
    }, {
      children: translate('registerSubmitButton')
    }))]
  })) : jsx(Confirmation, {
    codeDeliveryMedium: codeDeliveryDetails.DeliveryMedium,
    email: values.email || confirmAccountWithEmail,
    attributeValue: values[codeDeliveryDetails.AttributeName],
    close: close,
    confirmAccountWithEmail: confirmAccountWithEmail,
    confirmCallback: confirmCallback
  });
};
var Register = function Register(_ref3) {
  var _ref3$renderAs = _ref3.renderAs,
    Wrapper = _ref3$renderAs === void 0 ? Modal : _ref3$renderAs,
    _ref3$isWrapperCompon = _ref3.isWrapperComponent,
    isWrapperComponent = _ref3$isWrapperCompon === void 0 ? true : _ref3$isWrapperCompon,
    onClickSignIn = _ref3.onClickSignIn,
    confirmAccountWithEmail = _ref3.confirmAccountWithEmail,
    confirmCallback = _ref3.confirmCallback;
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useConfig = useConfig(),
    renderLogo = _useConfig.renderLogo;
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    codeDeliveryDetails = _useState10[0],
    setCodeDeliveryDetails = _useState10[1];
  var _useSignUp3 = useSignUp(),
    signUp = _useSignUp3.signUp,
    getSignUpFields = _useSignUp3.getSignUpFields,
    resendSignUpCode = _useSignUp3.resendSignUpCode;
  var _useTranslations3 = useTranslations(),
    translate = _useTranslations3.translate;
  var _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    signUpFields = _useState12[0],
    setSignUpFields = _useState12[1];
  var _useState13 = useState(true),
    _useState14 = _slicedToArray(_useState13, 2),
    pending = _useState14[0],
    setPending = _useState14[1];
  var _useGoogleReCaptcha = useGoogleReCaptcha(),
    executeRecaptcha = _useGoogleReCaptcha.executeRecaptcha;
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    submitPending = _useState16[0],
    setSubmitPending = _useState16[1];
  useEffect(function () {
    var getSignUpFieldsInit = function getSignUpFieldsInit() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var fields;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getSignUpFields();
              case 3:
                fields = _context3.sent;
                setSignUpFields(fields);
                setPending(false);
                _context3.next = 12;
                break;
              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                setErrorMessage(_context3.t0);
                setPending(false);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      }));
    };
    getSignUpFieldsInit();
  }, []);
  var close = function close() {
    triggerCustomEvent(Events.onSignUpClick, {
      visible: false
    });
  };
  var openLoginModal = function openLoginModal() {
    triggerCustomEvent(Events.onSignInClick, {
      visible: true
    });
  };
  var congratulationCallback = function congratulationCallback() {
    triggerCustomEvent(Events.onSuccessActionRegister, {
      visible: false
    });
    openLoginModal();
  };
  var openCongratulationModal = function openCongratulationModal() {
    triggerCustomEvent(Events.onSuccessActionRegister, {
      message: translate('registerCongratulationText'),
      title: translate('registerCongratulationTitle'),
      buttonTitle: translate('registerCongratulationButton'),
      callback: congratulationCallback,
      visible: true
    });
  };
  var fieldStatesInit = useMemo(function () {
    return Object.entries(signUpFields).reduce(function (prev, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        curr = _ref5[1];
      return Object.assign(Object.assign({}, prev), _defineProperty({}, key, ['checkbox', 'radio'].includes(curr.type) ? [] : ''));
    }, {});
  }, [signUpFields]);
  var removeSpecialSigns = function removeSpecialSigns(phoneValue) {
    var regex = /[^+^0-9]/g;
    return phoneValue.replaceAll(regex, '');
  };
  var submit = function submit(data) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var fields, token, user;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              fields = Object.keys(fieldStatesInit).reduce(function (result, key) {
                if (key === 'phone_number') {
                  return Object.assign(Object.assign({}, result), _defineProperty({}, key, removeSpecialSigns(data[key])));
                }
                return Object.assign(Object.assign({}, result), _defineProperty({}, key, data[key]));
              }, {});
              setSubmitPending(true);
              if (executeRecaptcha) {
                _context4.next = 6;
                break;
              }
              console.error('Execute recaptcha not yet available');
              setSubmitPending(false);
              return _context4.abrupt("return");
            case 6:
              _context4.next = 8;
              return executeRecaptcha('signUp');
            case 8:
              token = _context4.sent;
              _context4.next = 11;
              return signUp(Object.assign(Object.assign({}, fields), {
                captchaToken: token
              }));
            case 11:
              user = _context4.sent;
              if (user === null || user === void 0 ? void 0 : user.success) {
                setErrorMessage('');
                if (user.userConfirmed) {
                  close();
                  openCongratulationModal();
                } else if (user.codeDeliveryDetails) {
                  setCodeDeliveryDetails(user.codeDeliveryDetails);
                } else {
                  console.error('Unsupported error: no code delivery details');
                }
              } else {
                setErrorMessage(user.message);
              }
              setSubmitPending(false);
            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
  useEffect(function () {
    var resendConfirmationEmail = function resendConfirmationEmail() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (confirmAccountWithEmail) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                setCodeDeliveryDetails({
                  AttributeName: 'email',
                  DeliveryMedium: 'EMAIL',
                  Destination: confirmAccountWithEmail
                });
                _context5.next = 5;
                return resendSignUpCode({
                  username: confirmAccountWithEmail
                });
              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    };
    resendConfirmationEmail();
  }, [confirmAccountWithEmail]);
  var WrapperComponent = useCallback(function (children) {
    return jsx(Wrapper, Object.assign({
      isShowing: true,
      close: close,
      disableOnClickClose: true,
      className: styles$1.modal
    }, {
      children: children
    }));
  }, []);
  return jsx(ConditionalWrapper, Object.assign({
    condition: isWrapperComponent,
    wrapper: WrapperComponent
  }, {
    children: jsxs("div", Object.assign({
      className: classNames(styles$1.register, 'register'),
      id: "register"
    }, {
      children: [isWrapperComponent ? jsx(Button$1, Object.assign({
        variant: "close",
        onClick: close,
        type: "button",
        className: "register__close-button"
      }, {
        children: jsx(CloseIcon, {})
      })) : null, renderLogo ? renderLogo({
        className: styles$1.logo
      }) : null, jsxs("div", Object.assign({
        className: classNames(styles$1.container, 'register__container')
      }, {
        children: [pending ? jsx(Loader, {}) : jsx(RegisterForm, {
          signUpFields: signUpFields,
          onClickSignIn: onClickSignIn,
          submit: submit,
          codeDeliveryDetails: codeDeliveryDetails,
          close: close,
          pending: submitPending,
          confirmAccountWithEmail: confirmAccountWithEmail,
          confirmCallback: confirmCallback
        }), errorMessage ? jsx(ErrorMessage, {
          className: classNames(styles$1.errorMessage, 'register__error'),
          message: errorMessage
        }) : null]
      }))]
    }))
  }));
};
var RegisterWithRecaptchaProvider = function RegisterWithRecaptchaProvider(props) {
  var _useSignUp4 = useSignUp(),
    getRecapchaKey = _useSignUp4.getRecapchaKey;
  return jsx(GoogleReCaptchaProvider, Object.assign({
    reCaptchaKey: getRecapchaKey(),
    scriptProps: {
      async: false,
      defer: false,
      appendTo: 'head'
    }
  }, {
    children: jsx(Register, Object.assign({}, props))
  }));
};
export { RegisterWithRecaptchaProvider as default };